// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.embla {
    --slide-spacing: 1rem;
    --slide-size: 100%;
    /* --slide-height: 19rem; */
    /* padding: 1.6rem; */
  }
  .embla__viewport {
    overflow: hidden;
  }
  .embla__container {
    backface-visibility: hidden;
    display: flex;
    touch-action: pan-y;
    margin-left: calc(var(--slide-spacing) * -1);
  }
  .embla__slide {
    flex: 0 0 var(--slide-size);
    min-width: 0;
    padding-left: var(--slide-spacing);
    position: relative;
  }
  .embla__slide__img {
    display: block;
    /* height: var(--slide-height); */
    width: 100%;
    object-fit: cover;
  }
  .embla__slide__number {
    width: 4.6rem;
    /* height: 4.6rem; */
    z-index: 1;
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
    border-radius: 50%;
    background-color: rgba(var(--background-site-rgb-value), 0.85);
    /* line-height: 4.6rem; */
    font-weight: 900;
    text-align: center;
    pointer-events: none;
  }
  .embla__slide__number > span {
    color: var(--brand-primary);
    background-image: linear-gradient(
      45deg,
      var(--brand-primary),
      var(--brand-secondary)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 1.6rem;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .embla-thumbs {
    --thumbs-slide-spacing: 0.8rem;
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }
  .embla-thumbs__viewport {
    overflow: hidden;
  }
  .embla-thumbs__container {
    display: flex;
    flex-direction: row;
    margin-left: calc(var(--thumbs-slide-spacing) * -1);
  }
  .embla-thumbs__slide {
    flex: 0 0 28%;
    min-width: 0;
    padding-left: var(--thumbs-slide-spacing);
    position: relative;
  }
  @media (min-width: 576px) {
    .embla-thumbs__slide {
      flex: 0 0 18%;
    }
  }
  .embla-thumbs__slide__button {
    -webkit-appearance: none;
    background-color: transparent;
    touch-action: manipulation;
    display: block;
    text-decoration: none;
    cursor: pointer;
    border: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    opacity: 0.4;
    transition: opacity 0.2s;
  }
  .embla-thumbs__slide--selected .embla-thumbs__slide__button {
    opacity: 1;
    border-style: dotted solid double dashed;
  }
  .embla-thumbs__slide__img {
    display: block;
    /* height: var(--thumbs-slide-height); */
    width: 100%;
    object-fit: cover;
  }
  `, "",{"version":3,"sources":["webpack://./src/includes/slider/ProdViewSlider/embla.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;IAC3B,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,4CAA4C;EAC9C;EACA;IACE,2BAA2B;IAC3B,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,iCAAiC;IACjC,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,8DAA8D;IAC9D,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,2BAA2B;IAC3B;;;;KAIC;IACD,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;EACX;EACA;IACE,8BAA8B;IAC9B,iCAAiC;IACjC,uCAAuC;EACzC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mDAAmD;EACrD;EACA;IACE,aAAa;IACb,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;EACpB;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,0BAA0B;IAC1B,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,cAAc;IACd,wCAAwC;IACxC,WAAW;IACX,iBAAiB;EACnB","sourcesContent":[".embla {\n    --slide-spacing: 1rem;\n    --slide-size: 100%;\n    /* --slide-height: 19rem; */\n    /* padding: 1.6rem; */\n  }\n  .embla__viewport {\n    overflow: hidden;\n  }\n  .embla__container {\n    backface-visibility: hidden;\n    display: flex;\n    touch-action: pan-y;\n    margin-left: calc(var(--slide-spacing) * -1);\n  }\n  .embla__slide {\n    flex: 0 0 var(--slide-size);\n    min-width: 0;\n    padding-left: var(--slide-spacing);\n    position: relative;\n  }\n  .embla__slide__img {\n    display: block;\n    /* height: var(--slide-height); */\n    width: 100%;\n    object-fit: cover;\n  }\n  .embla__slide__number {\n    width: 4.6rem;\n    /* height: 4.6rem; */\n    z-index: 1;\n    position: absolute;\n    top: 0.6rem;\n    right: 0.6rem;\n    border-radius: 50%;\n    background-color: rgba(var(--background-site-rgb-value), 0.85);\n    /* line-height: 4.6rem; */\n    font-weight: 900;\n    text-align: center;\n    pointer-events: none;\n  }\n  .embla__slide__number > span {\n    color: var(--brand-primary);\n    background-image: linear-gradient(\n      45deg,\n      var(--brand-primary),\n      var(--brand-secondary)\n    );\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-size: 1.6rem;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n  .embla-thumbs {\n    --thumbs-slide-spacing: 0.8rem;\n    /* --thumbs-slide-height: 9rem; */\n    margin-top: var(--thumbs-slide-spacing);\n  }\n  .embla-thumbs__viewport {\n    overflow: hidden;\n  }\n  .embla-thumbs__container {\n    display: flex;\n    flex-direction: row;\n    margin-left: calc(var(--thumbs-slide-spacing) * -1);\n  }\n  .embla-thumbs__slide {\n    flex: 0 0 28%;\n    min-width: 0;\n    padding-left: var(--thumbs-slide-spacing);\n    position: relative;\n  }\n  @media (min-width: 576px) {\n    .embla-thumbs__slide {\n      flex: 0 0 18%;\n    }\n  }\n  .embla-thumbs__slide__button {\n    -webkit-appearance: none;\n    background-color: transparent;\n    touch-action: manipulation;\n    display: block;\n    text-decoration: none;\n    cursor: pointer;\n    border: 0;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    opacity: 0.4;\n    transition: opacity 0.2s;\n  }\n  .embla-thumbs__slide--selected .embla-thumbs__slide__button {\n    opacity: 1;\n    border-style: dotted solid double dashed;\n  }\n  .embla-thumbs__slide__img {\n    display: block;\n    /* height: var(--thumbs-slide-height); */\n    width: 100%;\n    object-fit: cover;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
